import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

/* NB Let op dat je vanuit hier geen circular ref maakt: dit component wordt gebruikt vanuit ApplicationUtilService !! */
/* NB Let op dat je vanuit hier geen circular ref maakt: dit component wordt gebruikt vanuit HttpWrapperService !! */
import { isEmptyValue } from '@helpers';
import { EcertDialogData } from '@modals/ecertnl-dialog-data.model';

export interface ConfirmDialogData extends EcertDialogData {
  positiveButton: string;
  negativeButton: string;
  headerText: string;
  messageText: string;
  positiveButtonFallback?: string;
  negativeButtonFallback?: string;
  headerTextFallback?: string;
  messageTextFallback?: string;
  messageTextParameters?: { [key: string]: string };
}

export const POSITIVE_BTN = 'positive';
export const NEGATIVE_BTN = 'negative';
export const CLOSE_BTN = 'close';
export const BACKGROUND = 'background';

@Component({
  selector: 'ecertnl-confirm-modal',
  templateUrl: './ecertnl-confirm-modal.component.html',
  styleUrls: ['./ecertnl-confirm-modal.component.css'],
  standalone: false,
})
export class EcertConfirmModalComponent implements OnInit, OnDestroy {
  protected isWarning = false;
  protected canLeave = true;
  protected pageHasErrors = false;

  private subscriptions: Subscription[] = [];
  // Aanpassing tov aanvragen-applicatie vanwege errormelding: TS2503: Cannot find namespace 'NodeJS'.
  // private timer: NodeJS.Timeout = null;
  private timer: ReturnType<typeof setTimeout> | null = null;

  private _positiveBTN: ElementRef;
  @ViewChild('posButton')
  private set positiveBTN(button: ElementRef) {
    this._positiveBTN = button;
    this._positiveBTN.nativeElement.focus();
  }

  constructor(public dialogRef: MatDialogRef<EcertConfirmModalComponent, string>, @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {
    this.canLeave = !this.dialogRef.disableClose;
    this.isWarning = data['isWarning'];
    this.pageHasErrors = data['pageHasErrors'] === undefined ? false : data['pageHasErrors'];
  }

  ngOnInit(): void {
    this.subscriptions.push(this.dialogRef.backdropClick().subscribe(() => this.backdropClicked()));
    this.timer = setTimeout(() => {
      this._positiveBTN.nativeElement.focus();
    }, 1000);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  protected positiveButton() {
    this.dialogRef.close(POSITIVE_BTN);
  }

  protected negativeButton() {
    this.dialogRef.close(NEGATIVE_BTN);
  }

  protected closeButton() {
    this.dialogRef.close(CLOSE_BTN);
  }

  protected hideNegativeButton() {
    return isEmptyValue(this.data.negativeButton);
  }

  private backdropClicked() {
    if (this.canLeave) {
      this.dialogRef.close(BACKGROUND);
    }
  }
}
